import React, { useState } from 'react';
import { ChevronDown, BookOpen } from 'lucide-react';
export function ValueStack() {
  const [openBonus, setOpenBonus] = useState<number | null>(null);
  const toggleBonus = (index: number) => {
    setOpenBonus(openBonus === index ? null : index);
  };
  const bonuses = [{
    title: 'PLAN DE EMERGENCIA EN SALA',
    value: '$17 USD',
    image: 'https://cdn.magicpatterns.com/uploads/eJsnadM4CnMCZ61YAqjZ1h/fotobono1.png',
    description: '¿Tráfico pesado en CDMX o lluvia en Santiago? Aprenda la rutina de 10 min que equivale a 1 hora de caminata. Calma total sin salir de casa.'
  }, {
    title: 'DIETA DEL FOCO - BIO-NUTRICIÓN',
    value: '$12 USD',
    image: 'https://cdn.magicpatterns.com/uploads/jHwQ7HkKmLiacFeHUXSHXj/fotobono2.png',
    description: '5 ajustes nutricionales para elevar la serotonina. Logre que su mascota ignore las distracciones de la calle y lo mire solo a usted.'
  }, {
    title: 'EL PERRO CAFETERO - PLAZAS',
    value: '$17 USD',
    image: 'https://cdn.magicpatterns.com/uploads/fMraebe9bYy3a1iGJKa9CZ/fotobono3.png',
    description: 'Protocolo técnico para modo desconexión en restaurantes. Disfrute de su café mientras él descansa a sus pies.'
  }];
  return <section className="py-12 px-4 bg-cloud-grey" data-id="element-160">
      <div className="max-w-5xl mx-auto" data-id="element-161">
        <div className="text-center mb-12" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-163">
            Todo lo que incluye su acceso hoy
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-164">
            El sistema completo para transformar la conducta de su perro.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 mb-12" data-id="element-165">
          {/* Main Product */}
          <div className="bg-white rounded-[20px] shadow-lg border-2 border-brand-teal overflow-hidden" data-id="element-166">
            <div className="bg-brand-teal text-white py-4 px-6 text-center" data-id="element-167">
              <h3 className="text-xl font-bold font-serif" data-id="element-168">
                El Método DOG-CALM
              </h3>
              <p className="text-teal-100 text-sm" data-id="element-169">Programa Principal</p>
            </div>
            <div className="p-6 flex flex-col md:flex-row gap-6 items-center" data-id="element-170">
              {/* Product Mockup */}
              <div className="w-full md:w-1/3 flex justify-center" data-id="element-171">
                <img src="https://cdn.magicpatterns.com/uploads/h4nX1CK9HnX9YFutro1y63/mockup_nuevo.png" alt="Pack DOG-CALM" className="w-48 h-auto rounded-[20px]" data-id="element-172" />
              </div>
              {/* Product Description */}
              <div className="flex-1 text-center md:text-left" data-id="element-173">
                <BookOpen className="w-16 h-16 text-brand-teal mb-4 mx-auto md:mx-0" data-id="element-174" />
                <p className="text-gray-700 mb-4" data-id="element-175">
                  El protocolo paso a paso para desactivar la reactividad y el
                  miedo en paseos.
                </p>
                <p className="font-bold text-gray-400 line-through" data-id="element-176">
                  Valor: $67 USD
                </p>
              </div>
            </div>
          </div>

          {/* Interactive Bonus Cards with Dropdowns */}
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-[20px] shadow-md border border-gray-200 overflow-hidden transition-all duration-300" data-id="element-177">
              <button onClick={() => toggleBonus(index)} className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-178">
                <div className="flex items-center gap-4 flex-1" data-id="element-179">
                  <img src={bonus.image} alt={bonus.title} className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-[12px] shadow-sm" data-id="element-180" />
                  <div className="text-left flex-1" data-id="element-181">
                    <div className="flex items-center gap-2 mb-1" data-id="element-182">
                      <span className="bg-brand-gold text-white text-[10px] font-bold px-2 py-1 rounded-full uppercase" data-id="element-183">
                        Bono {index + 1}
                      </span>
                    </div>
                    <h4 className="font-bold text-gray-900 text-sm sm:text-base" data-id="element-184">
                      {bonus.title}
                    </h4>
                    <p className="text-brand-gold font-semibold text-sm" data-id="element-185">
                      {bonus.value}
                    </p>
                  </div>
                </div>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 flex-shrink-0 ${openBonus === index ? 'rotate-180' : ''}`} data-id="element-186" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openBonus === index ? 'max-h-48' : 'max-h-0'}`} data-id="element-187">
                <div className="px-6 pb-6 pt-2 border-t border-gray-100" data-id="element-188">
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-189">
                    {bonus.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Pricing Summary */}
        <div className="bg-white rounded-[20px] shadow-xl p-8 max-w-2xl mx-auto text-center border border-gray-100" data-id="element-190">
          <div className="flex flex-col items-center justify-center space-y-2" data-id="element-191">
            <span className="text-gray-500 font-medium text-lg" data-id="element-192">
              VALOR REAL <span className="line-through" data-id="element-193">$113 USD</span>
            </span>
            <div className="text-5xl md:text-6xl font-black text-brand-teal font-serif my-4" data-id="element-194">
              PRECIO HOY: $9.95 USD
            </div>
            <p className="text-sm text-gray-500 font-medium uppercase tracking-widest" data-id="element-195">
              Pago único • Acceso de por vida
            </p>
          </div>
        </div>
      </div>
    </section>;
}